export default __webpack_public_path__ + "static/media/success_badge_ribbon.ec93bef3.svg";